<template>
  <div class="adsMgmt">
    <el-tabs v-model="country" @tab-click="handleClick">
      <el-tab-pane label="美国" name="1"></el-tab-pane>
      <el-tab-pane label="加拿大" name="2"></el-tab-pane>
      <el-tab-pane label="广告自动投放规则" name="3">
        <span class="title-font">
          手动关联商品：<br>
        </span>
        <span class="rule-text-font">
          1、排名>竞品&价格<竞品，添加该竞品投放<br>
        </span>
        <span class="rule-text-font" style="color: red;margin-left: 200px">
          或<br>
        </span>
        <span class="rule-text-font">
          2、竞品在similar items 中，本品不在或者排在竞品之后，添加该关联商品投放<br>
        </span>
        <br><br>
        <span class="title-font">
          自动关联商品：<br>
        </span>
        <span class="secondary-title-font">
          否定商品规则：<br>
        </span>
        <span class="rule-text-font">
          1、MOLOVA近3天日均销量排名前
          <input class="rule-input" v-model="rule.autoRelation.ruleDetail.threeDaySales.content.minSaleRank" @change="ruleDataChange(rule.autoRelation.adType,rule.autoRelation.ruleDetail.threeDaySales.type
                 , 1, rule.autoRelation.ruleDetail.threeDaySales.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          名，自动加入所有“自动关联商品”否定商品中<br>
        </span>
        <br><br>
        <span class="title-font">
          手动亚马逊关联商品：<br>
        </span>
        <span class="rule-text-font">
          1、
          <input class="rule-input" v-model="rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.maxDays" @change="ruleDataChange(rule.systemAmazonrelation.adType,rule.systemAmazonrelation.ruleDetail.orderAndRoas.type
                 , 1, rule.systemAmazonrelation.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          天内，自动关联商品广告产生订单数大于
          <input class="rule-input" v-model="rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.minOrders" @change="ruleDataChange(rule.systemAmazonrelation.adType,rule.systemAmazonrelation.ruleDetail.orderAndRoas.type
                 , 1, rule.systemAmazonrelation.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          单，并且ROAS高于
          <input class="rule-input" v-model="rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.minRoas" @change="ruleDataChange(rule.systemAmazonrelation.adType,rule.systemAmazonrelation.ruleDetail.orderAndRoas.type
                 , 1, rule.systemAmazonrelation.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          ，自动添加投放或打开，否则关闭(注：可与手动关联商品重复)<br>
        </span>
        <br><br>
        <span class="title-font">
          手动紧密匹配关键词：<br>
        </span>
        <span class="rule-text-font">
          1、如果竞品在<input class="rule-input" v-model="rule.manualKey.ruleDetail.keyword.content.maxPage" @change="ruleDataChange(rule.manualKey.adType,rule.manualKey.ruleDetail.keyword.type
                          , 1, rule.manualKey.ruleDetail.keyword.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          页以内,本品搜索页面的自然排名高于竞品则关闭广告，低于竞品则添加投放或开启<br>
        </span>
        <span class="rule-text-font" style="color: red;margin-left: 200px">
          或<br>
        </span>
        <span class="rule-text-font">
          2、
          <input class="rule-input" v-model="rule.manualKey.ruleDetail.orderAndRoas.content.maxDays" @change="ruleDataChange(rule.manualKey.adType,rule.manualKey.ruleDetail.orderAndRoas.type
                             , 1, rule.manualKey.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          天内，自动关联关键词广告产生订单数大于
          <input class="rule-input" v-model="rule.manualKey.ruleDetail.orderAndRoas.content.minOrders" @change="ruleDataChange(rule.manualKey.adType,rule.manualKey.ruleDetail.orderAndRoas.type
                             , 1, rule.manualKey.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          单，并且ROAS高于
          <input class="rule-input" v-model="rule.manualKey.ruleDetail.orderAndRoas.content.minRoas" @change="ruleDataChange(rule.manualKey.adType,rule.manualKey.ruleDetail.orderAndRoas.type
                             , 1, rule.manualKey.ruleDetail.orderAndRoas.content)" onkeyup="this.value=this.value.replace(/\D/g,'')"></input>
          ，自动添加投放或打开，否则关闭<br>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div v-if="country != '3'">
      <div class="header-box">
        <div class="header-line">
          <span class="header-label">时区</span>
          <el-select v-model="dsTimeZone" placeholder="请选择" size="small">
            <el-option v-for="item in timeZoneOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span class="header-label">日期</span>
          <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small" value-format="yyyy-MM-dd" style="width: 230px;">
          </el-date-picker>
          <el-button type="text" size="small" v-on:click="onPreDayBtnClick" style="width: auto;">前一天</el-button>
          <el-button type="text" size="small" v-on:click="onNextDayBtnClick" style="width: auto;margin-right: 15px;">
            后一天
          </el-button>
          <span class="header-label">asin</span>
          <el-input placeholder="请输入asin" v-model="asin" size="small" clearable>
          </el-input>
          <span class="header-label">中文简称</span>
          <el-input placeholder="请输入中文简称" v-model="innerName" size="small" clearable>
          </el-input>
          <span class="header-label">状态</span>
          <el-select v-model="status" placeholder="请选择" size="small">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="header-line">
          <span class="header-label">广告类型</span>
          <el-select v-model="nameType" placeholder="请选择" size="small">
            <el-option v-for="item in adsTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border size="mini" :cell-style="tableRowStyle" :row-key="getRowKeys" :expand-row-keys="expands" @expand-change="expandSelect" header-cell-class-name="table-header-cell">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.campaignsDTOList" style="width: 1173px;margin-left: 43px;" :show-header="false" :span-method="subListSpanMethod" :cell-style="tableRowStyle" v-if="props.$index != 0">
              <el-table-column width="249px" label="SKU/售价/库存/状态">
                <template>
                  <el-table :data="props.row.skuDTOList" style="width: 236px" border>
                    <el-table-column prop="sellerSKU" width="110px" label="SKU">
                    </el-table-column>
                    <el-table-column prop="unitPrice" width="45px" label="售价" :formatter="numberFormatter" align="right">
                    </el-table-column>
                    <el-table-column prop="inStockSupplyQuantity" width="40px" label="库存" align="right">
                    </el-table-column>
                    <el-table-column prop="transferSupplyQuantity" width="40px" label="调拨" align="right">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="typeText" width="80px" label="广告类型">
              </el-table-column>
              <el-table-column prop="status" width="55px" label="状态">
                <template v-slot="scope">
                  <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2" @change="((val) => {onSubTableStatusChange(val, scope.row)})">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="servingStatus" width="55px" label="广告运行状态">
              </el-table-column>
              <el-table-column prop="skuEnableRate" width="55px" label="SKU运行状态" align="right">
              </el-table-column>
              <el-table-column width="55px" label="前一天销量" align="right">
              </el-table-column>
              <el-table-column prop="dailyBudget" width="55px" label="广告预算">
                <template v-slot="scope">
                  <el-input v-model="scope.row.dailyBudget" size="small" style="width: 46px;text-align: right;" @change="((val) => {onBudgetOrBigPriceChange(val, scope.row, 'dailyBudget')})" @focus="onFocus"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="defaultBid" width="55px" label="设置竞价">
                <template v-slot="scope">
                  <el-input v-model="scope.row.defaultBid" size="small" style="width: 46px;" @change="((val) => {onBudgetOrBigPriceChange(val, scope.row, 'defaultBid')})" @focus="onFocus"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="averageSpend" width="50px" label="平均点击单价" :formatter="numberFormatter" align="right">
              </el-table-column>
              <el-table-column prop="spend" width="55px" label="花费" :formatter="numberFormatter" align="right">
              </el-table-column>
              <el-table-column prop="orders" width="55px" label="订单数" align="right">
              </el-table-column>
              <el-table-column prop="sales" width="55px" label="销售额" :formatter="numberFormatter" align="right">
              </el-table-column>
              <el-table-column prop="acos" width="55px" label="ROAS" align="right">
              </el-table-column>
              <el-table-column prop="impressions" width="55px" label="曝光量" align="right">
              </el-table-column>
              <el-table-column prop="clicks" width="55px" label="点击次数" align="right">
              </el-table-column>
              <el-table-column prop="clickRate" width="50px" label="点击率" :formatter="percentageFormatter" align="right">
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <router-link :to="{path:'/client/adsMgmt/adsActivitySetting/adsSpace',
                    query:{
                      campaignsId: scope.row.campaignId,
                      groupId: scope.row.groupId,
                      absType: scope.row.type,
                      type: 'activity',
                      country: country,
                      beginDate: date[0],
                      endDate: date[1],
                      asin: props.row.asin,
                      name: props.row.name
                      }
                    }" size="small" style="color: #3064c7;font-size: 12px;">广告活动设置</router-link>
                  <br>
                  <router-link :to="{path:'/client/adsMgmt/adsGroupSetting/adsPutInAuto',
                              query:{
                              campaignsId: scope.row.campaignId,
                              groupId: scope.row.groupId,
                              absType: scope.row.type,
                              defaultBid: scope.row.defaultBid,
                              asin: props.row.asin,
                              name: props.row.name,
                              type: 'group',
                              beginDate: date[0],
                              endDate: date[1]
                              },
                      }" size="small" style="color: #3064c7;font-size: 12px;">广告组设置</router-link>
                  <br>
                  <el-button @click="errorBtnClick(scope.row.campaignId)" type="text" size="small" style="color: #f56c6c;font-size: 12px;" v-if="scope.row.errorLogSize > 0">异常列表</el-button>

                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column width="50px" label="序号">
          <template slot-scope="scope">
            <span v-if="scope.$index != 0">{{beginIndex + scope.$index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imageUrl" width="60px" label="商品">
          <template v-slot="scope">
            <el-image style="height: 40px;width: 40px;" :src="imageSrc(scope.row, 'imageUrl')" fit="fill" v-if="scope.$index != 0">
            </el-image>
            <div style="height: 40px;width: 40px;" v-if="scope.$index == 0">
            </div>
          </template>
        </el-table-column>
        <el-table-column width="70px" label="中文简称">
          <template slot-scope="scope">
            <span class="ads-name" :title="scope.row.name" v-if="scope.$index != 0">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="asin" width="65px" label="asin">
        </el-table-column>
        <el-table-column width="80px" label="广告类型">
          <template slot-scope="scope">
            <span v-if="scope.$index != 0">合计</span>
          </template>
        </el-table-column>
        <el-table-column width="55px" label="状态">
        </el-table-column>
        <el-table-column prop="campaignActiveRate" width="55px" label="广告运行状态">
        </el-table-column>
        <el-table-column prop="skuEnableRateTotal" width="55px" label="SKU运行状态" align="right">
        </el-table-column>
        <el-table-column prop="yesterdaySalesCount" width="55px" label="前一天销量" align="right">
          <template slot-scope="scope">
            <span class="ads-name" v-if="scope.$index != 0">{{ scope.row.yesterdaySalesCount }}</span>
            <span v-if="scope.$index == 0">合计</span>
          </template>
        </el-table-column>
        <el-table-column prop="dailyBudget" width="55px" label="广告预算" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="defaultBidPrice" width="55px" label="设置竞价" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="averageSpend" width="55px" label="点击单价" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="spend" width="55px" label="花费" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="orders" width="55px" label="订单数" align="right" sortable>
        </el-table-column>
        <el-table-column prop="sales" width="55px" label="销售额" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="acos" width="55px" label="ROAS" align="right" :formatter="numberFormatter" sortable>
        </el-table-column>
        <el-table-column prop="impressions" width="55px" label="曝光量" align="right" sortable>
        </el-table-column>
        <el-table-column prop="clicks" width="55px" label="点击次数" align="right" sortable>
        </el-table-column>
        <el-table-column prop="clickRate" width="50px" label="点击率" align="right" :formatter="percentageFormatter" sortable :sort-method="sortClickRate">
        </el-table-column>
        <el-table-column label="操作">
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, next" background prev-text="上一页" next-text="下一页" :page-count="totalPage" @prev-click="prevBtnClick" @next-click="nextBtnClick">
      </el-pagination>
    </div>
    <el-dialog title="错误日志" :visible.sync="dialogFormVisible" width="80%">
      <ads-error-list :queryData="queryData" ref="errorListPage">
      </ads-error-list>
    </el-dialog>
  </div>
</template>

<script>
import { adsModules, adRuleModules } from '@r'
import adsErrorList from '@v/adsMgmt/children/adsErrorList'

export default {
  data() {
    return {
      dialogFormVisible: false,
      queryData: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            id: 'yesterday',
            text: '前一天',
            onClick: (picker) => {
              console.log(this);
              const end = this.date[0] || '';
              const start = this.date[1] || '';
              const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
              const newStart = new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
              picker.$emit('pick', [newStart, newEnd]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
      },
      date: [
        new Date(new Date().getHours() > 15 ? new Date().getTime() : new Date().getTime() - 3600 * 1000 * 24).format("yyyy-MM-dd"),
        new Date(new Date().getHours() > 15 ? new Date().getTime() : new Date().getTime() - 3600 * 1000 * 24).format("yyyy-MM-dd")
      ],
      timeZoneOptions: [
        {
          value: '0',
          label: '北京时间'
        }, {
          value: '1',
          label: '美国PST时间'
        }
      ],
      rule: {
        manualRelation: {
          adType: 3,
          ruleDetail: {
            rankAndPrice: {
              type: 1,
              content: {}
            },
            similarAsin: {
              type: 2,
              content: {}
            }
          }
        },
        autoRelation: {
          adType: 1,
          ruleDetail: {
            threeDaySales: {
              type: 3,
              content: {
                minSaleRank: 10,
              }
            }
          }
        },
        systemAmazonrelation: {
          adType: 5,
          ruleDetail: {
            orderAndRoas: {
              type: 4,
              content: {
                minRoas: 2,
                minOrders: 2,
                maxDays: 7,
              }
            }
          }
        },
        manualKey: {
          adType: 4,
          ruleDetail: {
            keyword: {
              type: 5,
              content: {
                maxPage: 5,
              }
            },
            orderAndRoas: {
              type: 4,
              content: {
                maxDays: 7,
                minRoas: 2,
                minOrders: 2,
              }
            }
          }
        },
      },
      dsTimeZone: '1',
      statusOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '启用'
        }, {
          value: '0',
          label: '停用'
        }
      ],
      adsTypeOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '自动关联商品'
        }, {
          value: '2',
          label: '自动紧密匹配'
        }, {
          value: '3',
          label: '手动关联商品'
        }, {
          value: '4',
          label: '手动紧密匹配关键词'
        }, {
          value: '5',
          label: '手动亚马逊关联商品'
        }
      ],
      operatorOptions: [
        {
          value: '1',
          label: '并且'
        }, {
          value: '0',
          label: '或者'
        }
      ],
      nameType: "",
      status: '',
      asin: '',
      innerName: '',
      focusValue: '',
      tableData: [],
      beginIndex: 0,
      pageSize: 50,
      totalPage: 1,
      currentPage: 1,
      country: '1',
      disabled: false,
      expandRowKeys: [],
      expands: [], // 通过该属性设置Table目前的展开行，需要设置row-key属性才能使用，该属性为展开行的keys数组
      firstChangeDate: false,
      ruleVisible: false,
    }
  },
  components: {
    adsErrorList
  },
  created() {
    // 解构
    const { beginDate, endDate, asin } = this.$route.query;
    asin && (this.asin = decodeURIComponent(asin));
    if (beginDate || endDate) {
      this.date = [beginDate || '', endDate || ''];
      this.firstChangeDate = true;
    }
    this.country = this.$route.query.country || "1";
    this.queryAdsList();
  },
  methods: {
    queryParams() {
      let params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        asin: this.asin,
        dsTimeZone: this.dsTimeZone,
        beginDate: this.date[0],
        endDate: this.date[1],
        name: this.innerName,
        status: this.status,
        nameType: this.nameType,
        country: this.country
      }
      return params;
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryAdsList();
    },
    queryAdsList() {
      this.expands = [];
      console.log('query ads list..')
      adsModules.getCampaignList(
        // 请求参数
        { params: this.queryParams() }
      ).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '列表获取失败'
          })
          return;
        }
        if (res.params.country != this.country) {
          console.log(res.params);
          return;
        }
        this.tableData = res.ldata;
        var mdata = res.mdata;

        this.asin && (this.expands.push(this.asin));
        this.currentPage = this.beginIndex / this.pageSize + 1;
        if (this.tableData.length >= this.pageSize) {
          this.tableData.pop();
          this.totalPage = this.currentPage + 1;
        }

        var totalInfo = {
          acos: mdata.averageAcos,
          asin: "",
          bid: mdata.averageBid,
          campaignActiveRate: "",
          campaignsDTOList: [],
          clickRate: mdata.averageClickRate,
          clicks: mdata.sumClicks,
          dailyBudget: mdata.sumDailyBudget,
          defaultBidPrice: mdata.averageDefaultBidPrice,
          imageUrl: "",
          impressions: mdata.sumImpressions,
          name: "",
          orders: mdata.sumOrders,
          sales: mdata.sumSales,
          skuDTOList: [],
          skuEnableRateTotal: "",
          spend: mdata.sumSpend,
          status: "",
          yesterdaySalesCount: mdata.sumYesterdaySalesCount,
          averageSpend: mdata.averageSpend,
        }

        this.tableData.splice(0, 0, totalInfo);

        if (this.firstChangeDate === false) {
          if (!['', undefined, null].includes(mdata.nowUSADate)) {
            this.date = [mdata.nowUSADate, mdata.nowUSADate];
          }
          this.firstChangeDate = true;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    onPreDayBtnClick() {
      var beginDate = new Date(new Date(this.date[0]).getTime() - 24 * 3600 * 1000).format("yyyy-MM-dd");
      var endDate = new Date(new Date(this.date[1]).getTime() - 24 * 3600 * 1000).format("yyyy-MM-dd");
      this.date = [beginDate, endDate];
      this.queryAdsList();
    },
    onNextDayBtnClick() {
      var beginDate = new Date(new Date(this.date[0]).getTime() + 24 * 3600 * 1000).format("yyyy-MM-dd");
      var endDate = new Date(new Date(this.date[1]).getTime() + 24 * 3600 * 1000).format("yyyy-MM-dd");
      this.date = [beginDate, endDate];
      this.queryAdsList();
    },
    subListSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return [5, 1]
        } else {
          return [1, 0]
        }
      }
    },
    tableRowStyle: function ({
      row,
      rowIndex
    }) {
      return 'padding:0px;'
    },
    // onSkuStatusChange: function (val, row) {
    //   adsModules.updateProductStatusBySku({
    //     sellerSKU: encodeURIComponent(row.sellerSKU),
    //     status: row.status,
    //     country: this.country
    //   }).then((res) => {
    //     if(res.result !== 1){
    //       this.$message({
    //         type: 'error',
    //         message: res.message ? res.message : '编辑失败'
    //       });
    //       return;
    //     }
    //     this.$message({
    //       type: 'success',
    //       message: '编辑成功!'
    //     });
    //   }).catch((err) => {
    //     console.log(err);
    //     this.$message({
    //         type: 'error',
    //         message: err.message ? err.message : '编辑失败'
    //       });
    //   });
    // },
    onStatusChange: function (val, row) {
      adsModules.updateProductStatusBySku({
        asin: row.asin,
        status: row.status,
        country: this.country
      }).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.message ? err.message : '编辑失败'
        });
      });
    },
    onSubTableStatusChange: function (val, row) {
      adsModules.updateCampaignStatusAndBudgetAndBid({
        campaignId: row.campaignId,
        dailyBudget: row.dailyBudget,
        defaultBid: row.defaultBid,
        status: row.status,
        country: this.country
      }).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.message ? err.message : '编辑失败'
        });
      });
    },
    onBudgetOrBigPriceChange: function (val, row, propName) {
      this.$confirm('是否确认修改广告预算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adsModules.updateCampaignStatusAndBudgetAndBid({
          campaignId: row.campaignId,
          dailyBudget: row.dailyBudget,
          defaultBid: row.defaultBid,
          status: row.status,
          country: this.country
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
        }).catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑失败'
          });
        });
      }).catch(() => {
        row[propName] = this.focusValue
        this.$message({
          type: 'info',
          message: '已取消'
        })
      });
    },
    onFocus: function (e) {
      console.log(e.currentTarget.value)
      this.focusValue = e.currentTarget.value
    },
    prevBtnClick() {
      if (this.beginIndex <= 0) {
        this.$message({
          type: 'info',
          message: '已经到头了!'
        })
        return;
      }
      this.beginIndex = this.beginIndex - this.pageSize;
      this.queryAdsList();
    },
    nextBtnClick() {
      if (this.tableData.length < this.pageSize) {
        this.$message({
          type: 'info',
          message: '没有更多了!'
        })
        return;
      }
      this.beginIndex = this.beginIndex + this.pageSize;
      this.queryAdsList();
    },
    numberFormatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(2);
    },
    percentageFormatter(row, column, cellValue, index) {
      if ([null, undefined, ''].includes(cellValue)) {
        return '--';
      }
      if (isNaN(+cellValue)) {
        return cellValue;
      }
      return this.$utils.floatRide(cellValue, 100).toFixed(2) + '%';
    },
    // table每次只能展开一行
    expandSelect(row, expandedRows) {
      this.expands = []
      if (expandedRows.length > 0) {
        row ? this.expands.push(row.asin) : ''
      }
    },
    getRowKeys(row) { // 行数据的Key
      return row.asin
    },
    handleClick(tab, event) {
      if (this.country != "3") {
        this.queryAdsList();
      } else {
        this.getRuleData();
      }
    },
    sortClickRate(rowA, rowB) {
      return parseFloat(rowA.clickRate) - parseFloat(rowB.clickRate);
    },
    imageSrc(row, propName) {
      return row[propName].replace('https://logcapital.cn', '');
    },
    errorBtnClick(campaignId) {
      this.queryData.campaignId = campaignId;
      if (this.$refs.errorListPage) {
        this.$refs.errorListPage.queryErrorList();
      }
      this.dialogFormVisible = true;
    },


    getRuleData: function () {
      adRuleModules.list({}).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '查询失败'
          });
          return;
        }
        let data = res.mdata.data;
        if (data[1]) {
          if (data[1].ruleDetail[3]) {
            this.rule.autoRelation.ruleDetail.threeDaySales.content.minSaleRank = data[1].ruleDetail[3].content.minSaleRank;
          }
        }
        if (data[2]) {
        }
        if (data[3]) {
          if (data[3].ruleDetail[1]) {
          }
          if (data[3].ruleDetail[2]) {
          }
        }
        if (data[4]) {
          if (data[4].ruleDetail[5]) {
            this.rule.manualKey.ruleDetail.keyword.content.maxPage = data[4].ruleDetail[5].content.maxPage;
          }
          if (data[4].ruleDetail[4]) {
            this.rule.manualKey.ruleDetail.orderAndRoas.content.maxDays = data[4].ruleDetail[4].content.maxDays;
            this.rule.manualKey.ruleDetail.orderAndRoas.content.minRoas = data[4].ruleDetail[4].content.minRoas;
            this.rule.manualKey.ruleDetail.orderAndRoas.content.minOrders = data[4].ruleDetail[4].content.minOrders;
          }
        }
        if (data[5]) {
          if (data[5].ruleDetail[4]) {
            this.rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.maxDays = data[5].ruleDetail[4].content.maxDays;
            this.rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.minRoas = data[5].ruleDetail[4].content.minRoas;
            this.rule.systemAmazonrelation.ruleDetail.orderAndRoas.content.minOrders = data[5].ruleDetail[4].content.minOrders;
          }
        }
        this.$message({
          type: 'success',
          message: '查询成功!'
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.message ? err.message : '查询失败'
        });
      });
    },

    ruleDataChange: function (adType, type, operator, content) {
      this.$confirm('是否修改广告自动投放规则', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adRuleModules.edit({
          adType: adType,
          type: type,
          operator: operator,
          content: JSON.stringify(content),
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
        }).catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.message ? err.message : '编辑失败'
          });
        });
      })

    },
  },
  watch: {
    beginIndex() {
      console.log('beginIndex');
      this.disabled = true;
    },
    tableData() {
      console.log('tableData');
      this.disabled = false;
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0px;
}

.el-pagination {
  width: auto;
  text-align: center;
}

.el-table__expanded-cell[class*="cell"] {
  padding: 0px 0px 0px 47px;
}

.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px 3px;

  .el-input {
    margin-right: 0px;
    margin-left: 0px;

    .el-input__inner {
      padding-left: 2px;
      padding-right: 2px;
    }
  }
}

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}

.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}

.router-slid-enter-active,
.router-slid-leave-active {
  transition: all 0.4s;
}

.router-slid-enter,
.router-slid-leave-active {
  transform: translate3d(2rem, 0, 0);
  opacity: 0;
}
.ads-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.expanded {
  td {
    border-top: solid 1px #3064c7;
  }
  td:first-child {
    border-left: solid 1px #3064c7;
  }
  td:last-child {
    border-right: solid 2px #3064c7;
  }
}
.expanded + tr {
  .el-table__expanded-cell {
    border-left: solid 1px #3064c7;
    border-bottom: solid 1px #3064c7;
    border-right: solid 2px #3064c7;
  }
}

.rule-input {
  width: 1.5%;
  height: 10px;
  display: inline-block;
}
.title-font {
  font-size: 15px;
}
.secondary-title-font {
  font-size: 14px;
  margin-left: 15px;
}
.rule-text-font {
  font-size: 13px;
  margin-left: 30px;
}
</style>
